
export default {
  props: ["error"]
};
